export default __webpack_public_path__ + "static/media/chad-logo-256.b5a7c4ad.png";